export default __webpack_public_path__ + "static/buyers-edge-79a4509565e6d432a8c77e7ca18d8ba6.png";